function Location() {
  return (
    <svg
      width={30}
      height={40}
      viewBox="0 0 30 40"
      data-testid="location-icon"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.33 39.193C2.087 22.737 0 21.048 0 15 0 6.716 6.652 0 14.857 0c8.206 0 14.857 6.716 14.857 15 0 6.048-2.087 7.737-13.33 24.193a1.848 1.848 0 01-3.054 0zm1.527-17.943c3.42 0 6.19-2.798 6.19-6.25s-2.77-6.25-6.19-6.25c-3.419 0-6.19 2.798-6.19 6.25s2.771 6.25 6.19 6.25z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Location;
